import { GET_PRODUCT_DATA, GET_PRODUCT_DATA_BY_ID, GET_ALL_PRODUCT_DATA, PRODUCT_INVENTORY_BY_PRODUCT_ID } from "../constants";
import { ApiCall } from "../../utils";

export const getProductsDataList =
  (request, page, debouncedHandleSearch, sortOrder, sortField, rowsPerPage) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const searchParam = debouncedHandleSearch
        ? `search=${debouncedHandleSearch}`
        : "";
      const result = await ApiCall.get(
        `/product_master?${searchParam}&sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${rowsPerPage}`,
        token
      );

      dispatch({type: GET_PRODUCT_DATA, payload: result.data})
      request.onSuccess();

    } catch (error) {
      request.onError(error);
    }
  };

export const addProductData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/product_master", request.payload, token);
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const updateProductData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.patch(`/product_master/${request.product_id}`, request.payload, token);
    request.onSuccess()
  } catch (error) {
    request.onError(error);
  }
};

export const deleteProductData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(`/product_master/${request.product_id}`, token);
    request.onSuccess()
  } catch (error) {
    request.onError(error);
  }
};

export const getProductDataById = (request) => async (dispatch, getState) => {
    try {
        const {auth: {token}} = getState();
        const result = await ApiCall.get(`/product_master/by_product_id/${request.product_id}`, token);
        dispatch({type: GET_PRODUCT_DATA_BY_ID, payload: result.data})
    } catch (error) {
        request.onError(error)
    }
}

export const getAllProductDataList = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.get("/product_master", token);
    dispatch({type: GET_ALL_PRODUCT_DATA, payload: result.data.data})
  } catch (error) {
    request.onError(error)
  }
}

export const getInventoryAvailableProduct = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.get(`/inventory/product/byId/${request.product_master_id}`, token);
    request.onSuccess(result)
  } catch (error) {
    request.onError(error)
  }
}

export const addBulkProductionOrder = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.post("/production_order/bulk", request.payload, token);
    request.onSuccess();
  } catch (error) {
    request.onError(error)
  }
}